import {isLabeled, isObject} from '../utils/types-utils';

export type LocFilter = (obj: any) => string;

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace angular {
        interface IFilterService {
            // eslint-disable-next-line @typescript-eslint/prefer-function-type
            (name: 'loc'): LocFilter;
        }
    }
}

/**
 * @ngdoc filter
 * @name loc
 * @module portaro.filters
 * @kind function
 *
 * @param {object} obj Input localization object. If not defined, returns `null`
 *
 * @return {string|null} Localization text
 *
 * @description
 * Filter returns the ` text ` property from an input object
 */
export default function locFilter(): LocFilter {
    return (obj: any) => {
        if (angular.isDefined(obj) && obj !== null) {
            let res = obj;

            if (isObject(res) && isLabeled(res)) {
                res = res.text;
            }

            return res;
        }

        return null;
    };
}

locFilter.filterName = 'loc';
